import script from "./DocForceView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocForceView.vue?vue&type=script&setup=true&lang=js"

import "./DocForceView.vue?vue&type=style&index=0&id=2b764d1e&lang=scss"

const __exports__ = script;

export default __exports__